











import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import PageBase from './PageBase'
import PageForm from '@/components/PageForm.vue'
import { Page } from '@/models/Page'

@Component({
	components: {
		PageForm,
	},
})
export default class NewPage extends PageBase {

	private submit(page: Page) {
		this.$store.dispatch('savePage', page).then(() => {
			this.$toasted.success('Page successfully created.')
			this.$router.push({ name: 'pages' })
		}, (error: any) => this.$toasted.error(`Error: ${page.errorArray}`))
	}
}
